import type React from "react";
import { type CSSProperties, useCallback, useEffect } from "react";
import { createPortal } from "react-dom";
import { Modal, Overlay } from "./styled";

interface IGenericModalProps {
  open: boolean;
  onRequestClose: () => void;
  children: React.ReactNode;
  modalStyle?: CSSProperties;
}

const GenericModal: React.FC<IGenericModalProps> = ({
  open,
  onRequestClose,
  children,
  modalStyle,
}) => {
  const handleEscapeKey = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onRequestClose();
      }
    },
    [onRequestClose]
  );

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "visible";
      document.addEventListener("keydown", handleEscapeKey);
    }

    return () => {
      document.body.style.overflow = "unset";
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [open, handleEscapeKey]);

  if (!open) return null;

  return createPortal(
    <Overlay onClick={onRequestClose}>
      <Modal
        role="dialog"
        aria-modal="true"
        style={modalStyle}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </Modal>
    </Overlay>,
    document.body
  );
};

export default GenericModal;
